import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {authorize} from "../../services/authService";
import {useNavigate} from 'react-router-dom';
import {getUserInfo} from "../../services/userInfoService";

export const ComponentAsideDefault = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [signAuthRequired, setSignAuthRequired] = useState(false);

    const getConfig = () => {
        const configEncoded = sessionStorage.getItem('configs');
        if (configEncoded) {
            const configDecoded = atob(configEncoded); // Decodificar base64
            return JSON.parse(configDecoded); // Parsear a JSON
        }
        return null; // Retorna null si no existe la configuración
    };

    const handleAuthorize = async () => {
        const config = getConfig();
        if (config && config.SIGN_AUTH_REQUIRED ) {
                sessionStorage.setItem('sentToSign', 'true');
        }
        try {
            window.location.href = await authorize(
                process.env.REACT_APP_IDPID,
                process.env.REACT_APP_RESPONSE_TYPE,
                process.env.REACT_APP_STATE,
                process.env.REACT_APP_REDIRECT_URI
            );
        } catch (error) {
            console.error('Authorization failed', error);
        }
    };

    const handleCancel = () => {
        navigate('/');
    };

    useEffect(() => {
        window.popupModal();
    }, [signAuthRequired]);

    useEffect(() => {
        if (sessionStorage.getItem('configs')) {
            const configs = JSON.parse(atob(sessionStorage.getItem('configs')));
            setSignAuthRequired(configs.SIGN_AUTH_REQUIRED);
        }
    }, []);

    return (
        <div className="component-aside-default">
            <div className="component-actions">
                {signAuthRequired && <button
                    style={{ marginTop: '100px' }}
                    type="button"
                    data-modal="modalSeleccionarApariencia"
                    className="btn-medium btn-primary modal-trigger"
                >{t('componentAsideDefault.sign')}
                </button>}
                {!signAuthRequired && <button
                    style={{ marginTop: '100px' }}
                    type="button"
                    className="btn-medium btn-primary"
                    onClick={handleAuthorize}
                >{t('componentAsideDefault.sign')}
                </button>}
                <button
                    style={{ marginTop: '10px' }}
                    type="button"
                    className="btn-medium btn-secondary"
                    onClick={handleCancel}
                >
                    {t('componentAsideDefault.cancel')}
                </button>
            </div>
        </div>
    );
};
